import { useEffect, useMemo, useState } from 'react';
import { ProductCard } from './ProductCard';
import { AgencyBundleCard } from './AgencyBundleCard';
import { UpsellCard } from './UpsellCard';
import { Templately } from './Templately';

export function ProductCardList({ cartData, ...restProps }) {
	const [showFree, setShowFree] = useState(false);
	const [monthFree, setMonthFree] = useState(1);

	const agencyLifetime = useMemo(() => {
		if (!cartData) {
			return null;
		}

		return cartData?.contents?.find(
			item => +item.id === 474227 && +item.options.price_id >= 2
		);
	}, [cartData]);

	const cartHasBetterDocs = useMemo(() => {
		if (!cartData) {
			return false;
		}

		return (
			cartData?.details?.filter(item => +item.id === 342422)?.length > 0
		);
	}, [cartData]);

	useEffect(() => {
		if (cartData && cartData.details && cartData.details.length) {
			const [ea] = cartData.details.filter(
				item => parseInt(item.id) === 4372
			);
			if (ea) {
				setShowFree(true);
				switch (parseInt(ea.item_number?.options?.price_id)) {
					case 3:
						setMonthFree(3);
						break;
					case 4:
						setMonthFree(6);
						break;
					default:
						setMonthFree(1);
						break;
				}
			} else {
				const [eb] = cartData.details.filter(
					item => parseInt(item.id) === 1677666
				);
				if (eb) {
					setShowFree(true);
					switch (parseInt(eb.item_number?.options?.price_id)) {
						case 2:
							setMonthFree(3);
							break;
						case 3:
						case 4:
						case 5:
						case 6:
							setMonthFree(6);
							break;
						default:
							setMonthFree(1);
							break;
					}
				} else {
					setShowFree(false);
				}
			}
		}
	}, [cartData]);

	const cartViews = useMemo(() => {
		if (cartData?.details) {
			const onlyProductCard = false;
			return cartData?.details.map((product, idx) => {
				if (product.id == 1882016 && cartHasBetterDocs) {
					return;
				}

				return (
					<li
						key={product?.name ?? idx}
						className={`wp-checkout-product-card-list-item ${!onlyProductCard ? 'no-border' : ''}`}
					>
						<ProductCard
							{...restProps}
							cartIndex={idx}
							cartData={cartData}
							product={product}
							isAgencyLifetime={agencyLifetime}
							showFree={showFree}
							monthFree={monthFree}
						/>
					</li>
				);
			});
		}

		return [];
	}, [cartData, showFree, monthFree]);

	return (
		<ul className="wp-checkout-product-card-list">
			{cartViews}

			<li className={`wp-checkout-product-card-list-item no-border`}>
				{showFree && !restProps.renewalDiscount && (
					<Templately month={monthFree} />
				)}
			</li>

			<li className={`wp-checkout-product-card-list-item no-border`}>
				<UpsellCard
					{...restProps}
					cartData={cartData}
				/>
			</li>
		</ul>
	);
}
